module.exports = __webpack_public_path__ + "assets/images/plus.svg?a24798e047d96c1d085781ed88e8069e";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/plus.svg
// module id = 611
// module chunks = 0